
export type Card = {
    text: string;
    translations: string[];
    level: number;
    solvedAt: number;
};

export const MAX_CARD_LEVEL = 4;